<template>
     	<div class="d-flex flex-1 h-100 overflow-auto">
    	<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
				<div class="custom-icon-wrapper">
					<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
				</div>
				<v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManagePublicAnnouncements") }}</v-toolbar-title>
			</v-toolbar>
			<div class="border-top p-4 flex-1 overflow-auto">
                <div class="d-flex gap-2 justify-content-end">
					<v-btn color="primary" @click="addUpdatePublicAnnouncementDialog = true">{{ $t("res_ButtonText_Add") }}</v-btn>
				</div>

				<Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex" 
					@pageIndexChanged="pageIndexChanged"></Pagination>

				<div class="d-flex flex-1 flex-column overflow-auto mt-2">
					<v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort 
						:headers="headers" :items="allPublicAnnouncements"  hide-default-footer
						header-fixed :class="{ 'no-data': allPublicAnnouncements.length == 0 }" :items-per-page="pagingData.pageSize">
						<template v-slot:no-data>
							<div> 
								<img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
								<p class="m-0">{{ $t("res_No_new_items_here") }}</p>
							</div>
						</template>
						<template v-slot:item="row">
							<tr>
                                <td v-html="row.item.title"></td>
                                <td v-html="row.item.titleAr"></td>
                                <td v-html="row.item.subtitle"></td>
                                <td v-html="row.item.subtitleAr"></td> 
                                <td v-html="row.item.description"></td>
                                <td v-html="row.item.descriptionAr"></td>
                                <td v-html="row.item.link"></td>
                                <td v-html="row.item.linkText"></td>
                                <td v-html="row.item.linkTextAr"></td>
                                <td v-html="row.item.imageUrl"></td>
                                <td>{{ getCompanyName(row.item.companyId) }}</td>
                                <td>{{ utils.formatDateTime(row.item.startDate) }}</td>
                                <td>{{ utils.formatDateTime(row.item.endDate) }}</td>
                                <td><span :class="'announcement-status ' + getAnnouncementStatus(row.item)">{{ getAnnouncementStatusLabel(row.item) }}</span></td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('res_ButtonText_Preview')" @click="previewAnnouncement(row.item)">mdi-eye-outline</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="row.item.isActive ? $t('res_Hover_Deactivate') : $t('res_Hover_Activate')"
												@click="ActivatePublicAnnouncement(row.item.id, !row.item.isActive)">{{ row.item.isActive ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('Update')" @click="UpdatePublicAnnouncement(row.item.id)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="DeletePublicAnnouncement(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
      		</div>
    	</v-card>

        <v-dialog v-model="addUpdatePublicAnnouncementDialog" max-width="700px">
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">
						<span v-if="addUpdatePublicAannouncemntItem.id > 0">{{ $t("res_ButtonText_UpdatePublicAnnouncement") }}</span>
						<span v-else>{{ $t("res_ButtonText_SavePublicAnnouncement") }}</span></v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="addUpdatePublicAnnouncementDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<div class="d-flex flex-column overflow-auto h-100">
					<div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="6" sm="12">
								<v-label>{{ $t("res_Label_Title") }} *</v-label>
                                <v-text-field v-model="addUpdatePublicAannouncemntItem.title" outlined></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-label>{{ $t('res_Label_TitleAr') }} *</v-label>
                                <v-text-field v-model="addUpdatePublicAannouncemntItem.titleAr" outlined></v-text-field>
							</v-col>
                            <v-col cols="6" sm="12">
								<v-label>{{ $t("res_GridHeaders_Subtitle") }} </v-label>
								<v-text-field v-model="addUpdatePublicAannouncemntItem.subtitle" outlined></v-text-field>
							</v-col>
                            <v-col cols="6" sm="12">
                                <v-label>{{ $t("res_GridHeaders_SubtitleAr") }} </v-label>
                                <v-text-field v-model="addUpdatePublicAannouncemntItem.subtitleAr" outlined></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-label>{{ $t("res_Label_Description") }} </v-label>
								<Editor v-model="addUpdatePublicAannouncemntItem.description" :formats="editorFormats" dir="ltr" editorStyle="height: 160px">
									<template v-slot:toolbar>
										<span class="ql-formats">
											<button class="ql-bold" type="button"></button>
											<button class="ql-italic" type="button"></button>
											<button class="ql-underline" type="button"></button>
										</span>
										<span class="ql-formats">
											<button class="ql-list" value="ordered" type="button"></button>
											<button class="ql-list" value="bullet" type="button"></button>
										</span>
										<span class="ql-formats">
											<button class="ql-link" type="button"></button>
											<button class="ql-clean" type="button"></button>
										</span>
									</template>
								</Editor>
							</v-col>
							<v-col cols="12">
								<v-label>{{ $t("res_Label_DescriptionAr") }} </v-label>
								<Editor v-model="addUpdatePublicAannouncemntItem.descriptionAr" :formats="editorFormats" dir="rtl" class="announcement-editor-rtl" editorStyle="height: 160px">
									<template v-slot:toolbar>
										<span class="ql-formats">
											<button class="ql-bold" type="button"></button>
											<button class="ql-italic" type="button"></button>
											<button class="ql-underline" type="button"></button>
										</span>
										<span class="ql-formats">
											<button class="ql-list" value="ordered" type="button"></button>
											<button class="ql-list" value="bullet" type="button"></button>
										</span>
										<span class="ql-formats">
											<button class="ql-link" type="button"></button>
											<button class="ql-clean" type="button"></button>
										</span>
									</template>
								</Editor>
							</v-col>
                           <v-col cols="6" sm="12">
								<v-label>{{ $t("res_GridHeaders_LinkText") }} </v-label>
								<v-text-field v-model="addUpdatePublicAannouncemntItem.linkText" outlined></v-text-field>
							</v-col>
                             <v-col cols="6" sm="12">
								<v-label>{{ $t("res_GridHeaders_LinkTextAr") }} </v-label>
								<v-text-field v-model="addUpdatePublicAannouncemntItem.linkTextAr" outlined></v-text-field>
							</v-col>
                            <v-col cols="6" sm="12">
								<v-label>{{ $t("res_Tooltip_Link") }} </v-label>
								<v-text-field v-model="addUpdatePublicAannouncemntItem.link" outlined></v-text-field>
							</v-col>
							<v-col cols="6" sm="12">
								<v-label>{{ $t("res_GridHeaders_ImageURL") }} </v-label>
								<v-text-field v-model="addUpdatePublicAannouncemntItem.imageUrl" outlined></v-text-field>
							</v-col>
                            <v-col cols="6" sm="12">
								<v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
								<multi-select class="light-bg add-arrow w-100" v-model="selectedCompany" label="name" track-by="id"
									open-direction="bottom" :options="company_items" :searchable="true"
									:internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
									:max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
									:allow-empty="true" :placeholder="$t('res_Label_AllCompanies')">
								</multi-select>
								<small class="grey--text">{{ $t("res_Msgs_LeaveEmptyForAllCompanies") }}</small>
							</v-col>
                            <v-col cols="6" sm="12">
								<v-label>{{ $t("StartDate") }} *</v-label>
								<v-menu content-class="p-0" v-model="startDateMenu" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(addUpdatePublicAannouncemntItem.startDate)" solo
                                            v-on="on" append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                            <template v-slot:append>
                                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker :locale="lang" :min="nowDate" v-model="addUpdatePublicAannouncemntItem.startDate" @input="startDateMenu = false"></v-date-picker>
                                </v-menu>
							</v-col>
                            <v-col cols="6" sm="12">
                                <v-label>{{ $t("EndDate") }} *</v-label>
                                <v-menu content-class="p-0" v-model="endDateMenu" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="shrink dtField" :label="$t('res_Label_SelectDate')" readonly :value="utils.dateFormat(addUpdatePublicAannouncemntItem.endDate)" solo
                                            v-on="on" append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                            <template v-slot:append>
                                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker :locale="lang" :min="getEndDateMin()" v-model="addUpdatePublicAannouncemntItem.endDate" @input="endDateMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
							<v-col cols="12">
								<v-switch v-model="addUpdatePublicAannouncemntItem.isActive" :label="$t('res_CheckBox_Active')" inset hide-details></v-switch>
							</v-col>
						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="previewAnnouncement(addUpdatePublicAannouncemntItem)">{{
							$t("res_ButtonText_Preview") }}</v-btn>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="addUpdatePublicAnnouncementDialog = false">{{
							$t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="addUpdatePublicAnnouncement()">{{
							$t("res_ButtonText_Save") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>

		<AnnouncementModal v-if="previewAnnouncementItem != null" :announcement="previewAnnouncementItem" :visible="showPreviewAnnouncement"
			@update:visible="showPreviewAnnouncement = $event" @close="showPreviewAnnouncement = false" />

		
  	</div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue';
import Editor from 'primevue/editor';
import MultiSelect from 'vue-multiselect';
import AnnouncementModal from '@/components/AnnouncementModal.vue';

function emptyAnnouncement() {
    return {
        id: 0,
        title: '',
        titleAr: '',
        subtitle: '',
        subtitleAr: '',
        description: '',
        descriptionAr: '',
        link: '',
        linkText: '',
        linkTextAr: '',
        imageUrl: '',
        companyId: null,
        isActive: false,
        startDate: window.newDate().toISOString().substr(0, 10),
        endDate: window.newDate().toISOString().substr(0, 10)
    };
}

export default {
    name: 'ManagePublicAnnouncements',
    components: { Pagination, Editor, MultiSelect, AnnouncementModal },
    data() {
        return {
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            utils: utils,
            headers: [
                    { text: this.$t("res_Label_Title"), value: 'title', width: "5%" },
                    { text: this.$t("res_Label_TitleAr"), value: 'titleAr', width: "5%" },
                    { text: this.$t("res_GridHeaders_Subtitle"), value: 'subtitle' , width: "8%" },
                    { text: this.$t("res_GridHeaders_SubtitleAr"), value: 'subtitleAr' , width: "8%" },
                    { text: this.$t("res_Label_Description"), value: 'description' , width: "10%" },
                    { text: this.$t("res_Label_DescriptionAr"), value: 'descriptionAr', width: "10%"  },
                    { text: this.$t("res_Tooltip_Link"), value: 'link', width: "5%"  },
                    { text: this.$t("res_GridHeaders_LinkText"), value: 'linkText', width: "8%"  },
                    { text: this.$t("res_GridHeaders_LinkTextAr"), value: 'linkTextAr', width: "8%"  },
                    { text: this.$t("res_GridHeaders_ImageURL"), value: 'imageUrl' , width: "5%" },
                    { text: this.$t("res_Label_Company"), value: 'companyId', width: "8%" },
                    { text: this.$t("res_GridHeaders_StartDate"), value: 'startDate', width: "5%"  },
                    { text: this.$t("res_GridHeaders_EndDate"), value: 'endDate', width: "5%"  },
                    { text: this.$t("res_Label_Status"), value: 'isActive', width: "5%" },
                    { text: "", value: "actions", sortable: false, width: "18%" },
                ],
            startDateMenu: false,
            endDateMenu: false,
            nowDate: window.newDate().toISOString().slice(0, 10),
            allPublicAnnouncements: [],
            addUpdatePublicAnnouncementDialog: false,
            addUpdatePublicAannouncemntItem: emptyAnnouncement(),
            company_items: [],
            selectedCompany: null,
            editorFormats: ['bold', 'italic', 'underline', 'list', 'link'],
            previewAnnouncementItem: null,
            showPreviewAnnouncement: false,
            lang: localStorage.getItem('lang') || 'en'
    }},
    methods: {
        backToAdminPage() {
            this.$router.push('/admin');
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;
            this.getAllPublicAnnouncements();
        },
        getCompaniesForUser() {
            axios.get(constants.baseApiUrl + 'Admin/GetCompaniesForUser')
                .then((res) => {
                    this.company_items = res.data.filter(x => x.external === false);
                })
                .catch((err) => console.warn(err));
        },
        getCompanyName(companyId) {
            if (companyId == null) {
                return this.$t('res_Label_AllCompanies');
            }
            var company = this.company_items.find(x => x.id == companyId);
            return company != null ? company.name : '';
        },
        async getAllPublicAnnouncements() {
            try {
                window.showLoading();
                const response = await axios.get(constants.baseApiUrl + 'Admin/GetAllPublicAnnouncements?pageSize=' + this.pagingData.pageSize + '&pageIndex=' + this.pagingData.pageIndex);
                this.allPublicAnnouncements = response.data.publicAnnouncements;
                this.pagingData.totalCount = response.data.totalRecords;
            } catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading();
            }
        },
        async addUpdatePublicAnnouncement() {
            try {
                var item = this.addUpdatePublicAannouncemntItem;
                if (!(item.title || '').trim() || !(item.titleAr || '').trim() || !item.startDate || !item.endDate) {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }
                if (item.endDate.substr(0, 10) < item.startDate.substr(0, 10)) {
                    window.showAlert('res_Msgs_FromDateGreaterThanToDate', 'warning')
                    return;
                }
                var hasLink = !!(item.link || '').trim();
                var hasLinkText = !!(item.linkText || '').trim() || !!(item.linkTextAr || '').trim();
                if (hasLink != hasLinkText) {
                    window.showAlert('res_Msgs_PublicAnnouncementLinkAndLinkText', 'warning')
                    return;
                }
                window.showLoading();
                this.addUpdatePublicAannouncemntItem.companyId = this.selectedCompany != null ? this.selectedCompany.id : null;
                const response = await axios.post(constants.baseApiUrl + 'Admin/AddUpdatePublicAnnouncement', this.addUpdatePublicAannouncemntItem);
                window.showAlert('res_Msgs_PublicAnnouncementSavedSuccess', 'success');
                this.addUpdatePublicAnnouncementDialog = false;
                this.resetForm();
                this.getAllPublicAnnouncements();

            } catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading();
            }
        },
        getAnnouncementStatus(item) {
            let retVal = 'active';
            let startDate = (item.startDate || '').substr(0, 10);
            let endDate = (item.endDate || '').substr(0, 10);
            if (!item.isActive)
                retVal = 'draft';
            else if (startDate > this.nowDate)
                retVal = 'scheduled';
            else if (endDate < this.nowDate)
                retVal = 'expired';
            return retVal;
        },
        getAnnouncementStatusLabel(item) {
            let labels = {
                draft: 'res_Label_AnnouncementDraft',
                scheduled: 'res_Label_AnnouncementScheduled',
                active: 'res_Label_Active',
                expired: 'res_Label_AnnouncementExpired'
            };
            let retVal = this.$t(labels[this.getAnnouncementStatus(item)]);
            return retVal;
        },
        previewAnnouncement(item) {
            // show the same fields a user of the current language would get
            let isArabic = this.lang == 'ar';
            this.previewAnnouncementItem = {
                id: item.id,
                title: isArabic ? item.titleAr : item.title,
                subtitle: isArabic ? item.subtitleAr : item.subtitle,
                description: isArabic ? item.descriptionAr : item.description,
                imageUrl: item.imageUrl,
                link: item.link,
                linkText: isArabic ? item.linkTextAr : item.linkText
            };
            this.showPreviewAnnouncement = true;
        },
        ActivatePublicAnnouncement(id, isActive) {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Admin/ActivatePublicAnnouncement?id=' + id + '&isActive=' + isActive)
                .then(response => {
                    window.showAlert('res_Msgs_PublicAnnouncementSavedSuccess', 'success');
                    this.getAllPublicAnnouncements();
                })
                .catch(error => alert(error))
                .finally(() => window.hideLoading())
        },
        getEndDateMin() {
            let startDate = this.addUpdatePublicAannouncemntItem.startDate;
            let retVal = startDate && startDate > this.nowDate ? startDate : this.nowDate;
            return retVal;
        },
        resetForm() {
            this.addUpdatePublicAannouncemntItem = emptyAnnouncement();
            this.selectedCompany = null;
        },
        UpdatePublicAnnouncement(id) {
            var announcement = this.allPublicAnnouncements.find(x => x.id == id);
            this.addUpdatePublicAannouncemntItem = {
                id: announcement.id,
                title: announcement.title,
                titleAr: announcement.titleAr,
                subtitle: announcement.subtitle,
                subtitleAr: announcement.subtitleAr,
                description: announcement.description,
                descriptionAr: announcement.descriptionAr,
                link: announcement.link,
                linkText: announcement.linkText,
                linkTextAr: announcement.linkTextAr,
                imageUrl: announcement.imageUrl,
                companyId: announcement.companyId,
                isActive: announcement.isActive,
                startDate: announcement.startDate ? announcement.startDate.substr(0, 10) : null,
                endDate: announcement.endDate ? announcement.endDate.substr(0, 10) : null
            };
            this.selectedCompany = announcement.companyId != null
                ? this.company_items.find(x => x.id == announcement.companyId) || null
                : null;
            this.addUpdatePublicAnnouncementDialog = true;
        },
        DeletePublicAnnouncement(id) {
            window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_EnsureRemovePublicAnnouncement'),
                () => {
                    window.showLoading() 
                    axios.get(constants.baseApiUrl + 'Admin/DeletePublicAnnouncement?id=' + id)
                        .then(() => {
                            window.showAlert('res_Msgs_PublicAnnouncementDeletedSuccess', 'success');
                            this.getAllPublicAnnouncements();
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            window.hideLoading();
                        });
                },
                () => { });
        }
    },
    mounted() {
        this.getCompaniesForUser();
        this.getAllPublicAnnouncements();
    },
    watch: {
        addUpdatePublicAnnouncementDialog(val) {
            if (!val) {
                this.resetForm();
            }
        }
    }
}

</script>
<style scoped>
/* Quill's list styles are LTR only - mirror them for the Arabic description */
div.announcement-editor-rtl ::v-deep ol,
div.announcement-editor-rtl ::v-deep ul {
    padding-left: 0;
    padding-right: 0;
}

div.announcement-editor-rtl ::v-deep ol > li,
div.announcement-editor-rtl ::v-deep ul > li {
    padding-left: 0;
    padding-right: 1.5rem;
}

div.announcement-editor-rtl ::v-deep ol > li::before,
div.announcement-editor-rtl ::v-deep ul > li::before {
    margin-left: 0.3rem;
    margin-right: -1.5rem;
    text-align: left;
}

.announcement-status {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    white-space: nowrap;
}

.announcement-status.draft {
    background: #eceff1;
    color: #546e7a;
}

.announcement-status.scheduled {
    background: #e3f2fd;
    color: #1565c0;
}

.announcement-status.active {
    background: #e0f2f1;
    color: #00796b;
}

.announcement-status.expired {
    background: #fbe9e7;
    color: #bf360c;
}
</style>
